/* eslint-disable @typescript-eslint/no-use-before-define */

import { ColoredSelectOption } from '@src/common/types';
import { getDfedsColorIterator } from '@src/common/util/dfedsColors/dfedsColorIterator';
import { getDfedsColors } from '../../common/util/dfedsColors/dfedsColors';
import { laIpAddressType } from './laIpAddressType';

export const laIdTypeColorAssignment = colorAssignmentFn();

function colorAssignmentFn() {
  const colors = getDfedsColors();
  const colorIterator = getDfedsColorIterator();

  const defaultColorMap: Record<string, ColoredSelectOption> = {
    device_id: { label: 'Device ID', value: 'device_id', color: colors[0] },
    email: { label: 'Email', value: 'email', color: colors[1] },
    [laIpAddressType]: {
      label: 'IP Address',
      value: laIpAddressType,
      color: colors[2],
    },
    optum_id: { label: 'Optum ID', value: 'optum_id', color: colors[3] },
    phone_number: {
      label: 'Phone Number',
      value: 'phone_number',
      color: colors[4],
    },
    tin: { label: 'TIN', value: 'tin', color: colors[5] },
    uuid: { label: 'UUID', value: 'uuid', color: colors[6] },
  };
  let colorMap = { ...defaultColorMap };

  return {
    getItem,
    reset,
  };

  function getItem(type: string): ColoredSelectOption {
    const item = colorMap[type];
    if (!item) {
      colorMap[type] = {
        label: colorIterator.beFriendly(type),
        value: type,
        color: colorIterator.getNextColor(colorMap),
      };
    }
    return colorMap[type];
  }

  function reset() {
    colorMap = { ...defaultColorMap };
  }
}
